module.exports = __webpack_public_path__ + "img/KK0040C-GL.635ba38c.jpg";